<template>
  <div>
    <form
      class=""
      @submit="submitFormHandler">
      <div class="form-group email-container">
        <div class="row gs-row">
          <div class="col">
            <div class="">
              <input
              class="email-input form-control"
              placeholder="Enter email..."
              v-model="email" />
            </div>
            <button class="btn btn-theme btn-email d-inline-block" type="submit" :disabled="this.email.length <= 0">
              Learn More
            </button>
          </div>
      </div>
      </div>
      <div class="waitlist-count" v-if="false"> <!-- Reenable if we want to do a waitlist -->
        <p>
          <span>
            <span class="full-op" v-if="this.landingCount">{{ this.landingCount }}</span>
            <span v-else>-</span>
          </span>
          on waitlist for Chrome Extension...</p>
      </div>
    </form>

  </div>
</template>

<script>
const axios = require('axios');
import {firebase, firebaseui, firebaseuiConfig, firestoreDB, firebaseStorage} from '@/common/firebaseConfig.js'

export default {
  props: {
  },
  data(){
    return {
      email: '',
      landingCount: null,
    }
  },
  computed : {},
  mounted: function() {
    // Used to fetch waitlist numbers
    /* const countRef = firestoreDB.collection('countData').doc('landingCount');
    countRef.get().then((querySnapshot) => {
      if(querySnapshot.exists){
        this.landingCount = querySnapshot.data().count
       }
       console.log("landingCount", this.landingCount)
     })
     .catch(function(error) {
         console.log("Error getting count data: ", error);
     });
      */
  },
  methods : {
    submitFormHandler: function (e) {
      e.preventDefault();
      if(this.email.length>0){
        alert("Thanks for your interest.  We'll reach out to provide access over the next few weeks.");
        var userDataRef = firestoreDB.collection('landingSignups').add({
          email: this.email,
          signupDate: new Date()
        }).then(() => {
          // console.log('Signup successfully added');
          // fbq('track', 'CompleteRegistration');
          // TODO: Add the facebook conversion pixel for marketing
          this.email = "";
        })
        .catch((error) => {
          console.log('error', error);
        });
        this.$ga.event({
          eventCategory: 'landing-page-action',
          eventAction: 'request-for-information-email',
          eventLabel: this.email
          // eventValue: this.email // needs to be an integer
        });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .gs-row {
    max-width: 500px;
    margin-top: 20px;
  }
  .email-container {
    vertical-align: top;
    margin-bottom: 0px;
  }
  .email-input {
    width: 100%;
  }
  .btn-email {
    cursor: pointer;
    margin-top: 6px;
  }

  @media (max-width: 768px) {
  }

  @media (min-width: 768px) {
  }
</style>
